import {
  HexAlphaColorPicker,
  HexColorPicker,
  RgbaStringColorPicker,
  RgbStringColorPicker,
} from "react-colorful";
import { ColorPickerBaseProps } from "react-colorful/dist/types";
import { SupportedColorPickerModes } from "./ColorPicker.types";

// see supported modes in react-colorful https://github.com/omgovich/react-colorful#supported-color-models
export const COLORPICKER_MODES = Object.freeze({
  HEX: "hex",
  HEX_ALPHA: "hex-alpha",
  RGB: "rgb",
  RGBA: "rgba",
});

export const ColorpickerComponentsMap: Record<
  SupportedColorPickerModes,
  (props: Partial<ColorPickerBaseProps<string>>) => JSX.Element
> = {
  [COLORPICKER_MODES.HEX_ALPHA]: HexAlphaColorPicker,
  [COLORPICKER_MODES.HEX]: HexColorPicker,
  [COLORPICKER_MODES.RGB]: RgbStringColorPicker,
  [COLORPICKER_MODES.RGBA]: RgbaStringColorPicker,
};

export function isWithAlphaMode(colorpickerMode: SupportedColorPickerModes) {
  return (
    [
      COLORPICKER_MODES.HEX_ALPHA,
      COLORPICKER_MODES.RGBA,
    ] as SupportedColorPickerModes[]
  ).includes(colorpickerMode);
}
